import { AddAmbarRequestOvertimePersonnel } from "../../../../models/request/ambar/AddAmbarRequest";
import { GetAmbarByIdResponseOvertimePersonnel } from "../../../../models/response/ambar/GetAmbarByIdResponse";

/**
 * Siparişle birlikte gönderilecek mesai satırlarını hazırlar.
 *
 * İki kural var ve ikisi de sessizce bozulabilir:
 *   1. "Mesai - Yol - Yemek" anahtarı kapalıysa hiçbir satır gönderilmez.
 *      Boş liste gönderilir ki sunucu daha önce kaydedilmiş satırları pasife alsın;
 *      alan hiç gönderilmezse eski satırlar kayıtta kalırdı.
 *   2. Personeli seçilmemiş satır gönderilmez — kullanıcı "Satır Ekle" deyip
 *      doldurmadan kaydettiğinde boş kayıt oluşmasın.
 */
export const gonderilecekMesaiSatirlari = (
    _mesaiAcik: boolean,
    _satirlar: GetAmbarByIdResponseOvertimePersonnel[] | undefined
): AddAmbarRequestOvertimePersonnel[] => {
    if (!_mesaiAcik)
        return [];

    return (_satirlar ?? [])
        .filter(x => x != null && x.personnelId != undefined && x.personnelId != null && x.personnelId != '')
        .map(x => ({
            ambarOvertimePersonnelId: x.ambarOvertimePersonnelId,
            personnelId: x.personnelId,
            hours: x.hours?.toString(),
            description: x.description,
        }));
}
